import React, { useState, useRef, useEffect } from 'react';
import Link from 'next/link';
import Accordian from '../../../../utils/accordion';
// import "./style.scss";
import dynamic from 'next/dynamic';
// import 'react-phone-input-2/lib/style.css';
import RequestInfoModal from '../../../common/requestInfoModal';
import { shallowEqual, useDispatch, useSelector } from "react-redux";

function Advanced(props) {
	const elementRef = useRef([]);
	const islamic_theologies_data = props?.islamicTheologiesData.length ? props?.islamicTheologiesData[0] : null;

	let data = islamic_theologies_data?.theology_accordion[0];
	let arabicData = [];
	if (data && Object.keys(data).length) {
		arabicData = data?.theology_accordions?.map((key, index) => {
			return {
				heading: key.heading,
				content: key.content,
				open: false
			};
		});
	}

	const [arabicTitle, setArabicTitle] = useState(data.heading);
	const [arabicSubTitle, setArabicSubTitle] = useState(data.subHeading);
	const [arabic, setArabic] = useState(arabicData);

	data = islamic_theologies_data?.theology_accordion[1];
	let electiveData = [];
	if (data && Object.keys(data).length) {
		electiveData = data?.theology_accordions?.map((key, index) => {
			return {
				heading: key.heading,
				content: key.content,
				open: false
			};
		});
	}

	const [electiveTitle, setElectiveTitle] = useState(data.heading);
	const [electiveSubTitle, setElectiveSubTitle] = useState(data.subHeading);
	const [elective, setElective] = useState(electiveData);


	const { userId } = useSelector((state) => ({
		userId: state.userAuth.userId,
	}), shallowEqual);

	const [accordions, setAccordions] = useState([
		{
			heading: 'The Quran: Composition, Collection, and Teachings',
			content: '<h3>The Quran: Composition, Collection, and Teachings</h3><p>This course aims to introduce students to the collection, compilation and standardization of the Qur’an along with its main features, structure, and themes. We will examine the different interpretive processes and approaches employed by exegetes, from the classical to the modern period, to yield meaning that is relevant to confront theological, legal and social issues. The course will also address the role of the Qur’an in everyday life and thought of a Muslim.</p>',
			open: false
		},
		{
			heading: 'Islamic Theology and Philosophy',
			content: '<h3>Islamic Theology and Philosophy</h3><p>This course is an introduction to the major figures, issues, discussions, and texts of Islamic thought as manifested in the interconnected domains of theology and philosophy. A developmental/ chronological approach will draw connections with other religious and philosophical traditions, and demonstrate confluence and change within Islamic thought over time. Students will also evaluate claims regarding “decline” in Islamic thought in connection to modernity.</p>',
			open: false
		},
		{
			heading: 'Islamic Law and Legal Theory',
			content: '<h3>Islamic Law and Legal Theory</h3><p>This course explains the internal workings of Islamic law at its theoretical roots. It engages students with the tools of ijtihad (the mechanism of Islamic legal reasoning) with an eye to the interpretive methodologies of the various schools of Islamic law. It also explores the relationship between Islamic law and government and surveys two selected areas of substantive law: family and criminal law. It concludes with a look at modern Islamic legal and political reform.</p>',
			open: false
		},
		{
			heading: 'History of Islam',
			content: '<h3>History of Islam</h3><p>This course outlines the expansion of Islam, the rise of the Umayyads; the Abbasid empire and successor states; the emergence of classical Islamic societies and material culture (including architecture, arts, literature); the Crusades and Mongol invasions and Muslim societies’ response; trade and exchange in the Mediterranean and Indian Oceans; the Ottoman/Safavid/Mughal empires; and the anti-colonial intellectual and political responses of new Muslim nation-states. The course provides a foundation for understanding contemporary Muslim societies and transnational Islam.</p>',
			open: false
		},
		{
			heading: 'Islamic Ethics',
			content: '<h3>Islamic Ethics</h3><p>This course surveys the literature in Islamic ethical thought, identifying key themes and topics for Muslims committed to living Islam as a way of life. Students explore how diverse Muslims have chosen to navigate the challenges of global modernity. They also examine how Islamic principles can help Muslims live with integrity in contemporary American society.</p>',
			open: false
		},
		{
			heading: 'Islamic Leadership and Spirituality',
			content: '<h3>Islamic Leadership and Spirituality</h3><p>This course provides an overview of models of religious leadership in the Muslim context, from both an historical perspective as well as a contemporary one. Students will study texts that describe the ideal components of Islamic leadership and spirituality and will build essential skills needed to operate as a leader in contemporary Muslim settings with a focus on youth, education, finances, board relations, gender issues, counseling, issuing of religious edicts (fatawa), communication with the community, janaza services, conversion, and interfaith.</p>',
			open: false
		},
	]);

	const [openRequestInfoModal, setOpenRequestInfoModal] = useState(false);

	const requestInfoCheck = () => {
		setOpenRequestInfoModal(true);
	}

	const closeModals = () => {
		setOpenRequestInfoModal(false);
	}

	return (
		<div id="advanced" className="degree-page">
			{openRequestInfoModal &&
				<RequestInfoModal
					closeModals={closeModals}
				/>
			}

			<>
				<div ref={el => elementRef.current["islamic-degree-sub-header"] = el} className="islamic-degree-sub-header w3-animate-zoom">
					{/*<img src={`${process.env.IMAGES_BASE_URL}/static-content/advanced-islamic-theology-banner.jpg.webp`} alt="Islamic Theology" />*/}
					<img src={`${process.env.CMS_API_ORIGIN}${islamic_theologies_data?.theology_header?.image?.url}`} alt="Islamic Theology" />
					{/*<p> Islamic Theology</p>*/}
					<p>{props?.islamicTheologiesData[0]?.theology_header?.title ?? null}</p>
					{/* <p ><span onClick={() => handleScrollToElement("islamic-chaplaincy", true)}><span className="back-btn"></span> Back</span>  {subHeaderInfo.text}</p> */}
				</div>
				<div className="container w3-animate-bottom" ref={el => elementRef.current["islamic-degree-sub-header-text"] = el}>

					<div className="row my-4">
						<div className="col-8">
							<div className="dfadfs" dangerouslySetInnerHTML={{ __html: islamic_theologies_data?.theology_body?.content }}></div>
							<h5><strong>{arabicTitle}</strong></h5>
							<h5>{arabicSubTitle ?? ''}</h5>
							<div>
								{arabic.length ? <Accordian accordions={arabic} setAccordions={setArabic} /> : null}
							</div>
							<br />
							<br />
							<h5><strong>{electiveTitle ?? ''}</strong></h5>
							<h5>{electiveSubTitle ?? ''}</h5>
							<div>
								{elective.length ? <Accordian accordions={elective} setAccordions={setElective} /> : null}
							</div>
						</div>
					</div>

					<div>
					</div>
				</div>
			</>
		</div>
	);
}

export default Advanced;
